import { render } from "./CreateNewUserModal.vue?vue&type=template&id=00df6621&scoped=true"
import script from "./CreateNewUserModal.vue?vue&type=script&lang=js"
export * from "./CreateNewUserModal.vue?vue&type=script&lang=js"

import "./CreateNewUserModal.vue?vue&type=style&index=0&id=00df6621&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00df6621"]])

export default __exports__